import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServerConfigService } from 'src/app/services/server-config.service';
import { Observable, throwError } from 'rxjs';
import { ParameterHandlerService } from 'projects/common/src/app/services';
import { IMachineContext } from 'projects/common/src/app/interfaces/machine-context';
import { IUser } from 'projects/common/src/app/interfaces';
import { environment } from 'src/environments/environment';
import { UrlBuilderService } from 'projects/communication/src/app/services/url-builder.service';

@Injectable({
  providedIn: 'root',
})
export class StatusService {
  private url = `http://${this.configServer.current.host}:${this.configServer.current.port}`;

  constructor(
    private http: HttpClient,
    private configServer: ServerConfigService,
    private parameterService: ParameterHandlerService,
    private urlBuilder: UrlBuilderService,
  ) {}

  /**
   * Function to get the status by id
   *
   * @param statusId: Status id
   */
  public getStatusById(statusId: number): Observable<any> {
    const endpoint = `status/${statusId}`;
    return this.http.get(`${this.urlBuilder.apiUrl}/${endpoint}`);
  }

  /**
   * Function to get all status
   */
  public getAllStatus(): Observable<any> {
    const endpoint = `status`;
    const machine = this.parameterService.parameters.item('machine-context').value as IMachineContext;
    const user = this.parameterService.parameters.item('user-data').value as IUser;
    const params: any = {
      machineTypeId: machine.machineTypeId,
      companyId: user.company.id,
    };
    return this.http.get(`${this.urlBuilder.apiUrl}/${endpoint}`, { params });
  }

  /**
   * Function to get machine status for dashboard
   */
  public getAllMachineStatus(params: any): Observable<any> {
    const endpoint = `status/statusmachine`;
    return this.http.get(`${this.urlBuilder.apiUrl}/${endpoint}`, { params });
  }

  /**
   * Function to insert a new row to machine status
   *
   * @param params Params to update machine
   */
  public updateStatusToMachine(params: any): Observable<any> {
    const endpoint = `status/statusmachineinsert`;
    return this.http.post(`${this.urlBuilder.apiUrl}/${endpoint}`, params);
  }

  /**
   * Get information of summary team
   */
  public getStatusDetail(params: any): Observable<any> {
    const endpoint = `Status/MachineStatusDetail`;
    return this.http.get(`${this.urlBuilder.apiUrl}/${endpoint}`, { params });
  }

  /**
   * Get all park zone
   */
  public getParkZone(): Observable<any> {
    const clientZoneType = environment.clientZoneType ? environment.clientZoneType : '1';
    const endpoint = `Zone/GetZoneByZoneType/${clientZoneType}`;
    return this.http.get(`${this.urlBuilder.apiUrl}/${endpoint}`);
  }

  /**
   * Uodate Status Park Zone
   */
  public updateStatusParkZone(params: any): Observable<any> {
    const endpoint = `Status/MachineMineUpdate`;
    return this.http.post<any>(`${this.urlBuilder.apiUrl}/${endpoint}`, params);
  }

  /**
   * Update Status
   */
  public updateStatusInsert(params: any): Observable<any> {
    const endpoint = `Status/StatusMachineInsert`;
    return this.http.post<any>(`${this.urlBuilder.apiUrl}/${endpoint}`, params);
  }

  /**
   * Get Zones type with childs
   */
  public getZonesChilds(): Promise<any> {
    const endpoint = `Zone/zonesflat`;
    return this.http.get(`${this.urlBuilder.apiUrl}/${endpoint}`).toPromise();
  }

  /**
   * Update Ubication
   */
  public updateUbicationInsert(params: any): Observable<any> {
    const endpoint = `Zone/InsertTrackingSync`;
    return this.http.post<any>(`${this.urlBuilder.apiUrl}/${endpoint}`, params);
  }

  /**
   * Handle error
   *
   * @param err error
   */
  private handleError(err: any): Observable<any> {
    return throwError(err);
  }
}
